import "./style.css";

function Article({ articleTitle, articleDescription, imageLinks = [] }) {
  const carouselId = `article-carousel-${articleTitle?.replace(/\s+/g, "-") || "item"}`;
  const showArrows = imageLinks.length > 4;
  const carouselClassName = `article-carousel${
    imageLinks.length > 0 && imageLinks.length < 4 ? " article-carousel-centered" : ""
  }`;

  const scrollCarousel = (direction) => {
    const node = document.getElementById(carouselId);
    if (!node) return;
    const amount = Math.max(260, node.clientWidth * 0.85);
    node.scrollBy({ left: amount * direction, behavior: "smooth" });
  };

  return (
    <div className="article-block">
      <h4 className="article-title">{articleTitle}</h4>
      <p className="article-description">{articleDescription}</p>
      <div className="article-carousel-wrap">
        {showArrows && (
          <>
            <button
              className="article-carousel-arrow left"
              type="button"
              onClick={() => scrollCarousel(-1)}
              aria-label="Scroll images left"
            >
              ◀
            </button>
            <button
              className="article-carousel-arrow right"
              type="button"
              onClick={() => scrollCarousel(1)}
              aria-label="Scroll images right"
            >
              ▶
            </button>
          </>
        )}
        <div className={carouselClassName} id={carouselId}>
          {imageLinks.map((val, index) => (
            <div className="article-carousel-item" key={`${val}-${index}`}>
              <img src={val} alt={articleTitle || ""} />
            </div>
          ))}
        </div>
      </div>
      <div className="article-divider" aria-hidden="true"></div>
    </div>
  );
}
export default Article;
